import React, { Component, PureComponent } from "react";
import {
  Text,
  View,
  ScrollView,
  Image,
  TouchableOpacity,
  SafeAreaView,
  StatusBar,
  ActivityIndicator,
  Platform,
  Alert,
  Dimensions,
  ImageBackground,
} from "react-native";
import data from "../imageData";
import * as Font from "expo-font";
import { LinearGradient } from "expo-linear-gradient";
import { FontAwesome } from "@expo/vector-icons";
import { SvgCss } from "react-native-svg";
import firebase from "firebase";
import "firebase/firestore";
import CachedImage from "../../../shared/CachedImage";
import ShopPreview from "../shared/ShopPreview";

const pencilIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="77.849" height="77.849" viewBox="0 0 77.849 77.849"><defs><style>.a{fill:#f4f1f1;}.b{fill:#e7dfdd;}.c{fill:#38336b;}.d{fill:#90d960;}.e{fill:#ffda2c;}.f{fill:#febf00;}.g{fill:#d20041;}.h{fill:#ba003a;}</style></defs><path class="a" d="M425.522,372.708l-2.658-7.342H412.97l-2.657,7.342a2.281,2.281,0,0,0,.072,1.728l5.46,11.9a2.281,2.281,0,0,0,4.146,0l5.46-11.9A2.281,2.281,0,0,0,425.522,372.708Z" transform="translate(-347.81 -309.813)"/><path class="b" d="M468.695,372.708l-2.657-7.342H461.09v22.3a2.281,2.281,0,0,0,2.073-1.329l5.46-11.9A2.281,2.281,0,0,0,468.695,372.708Z" transform="translate(-390.982 -309.813)"/><path class="a" d="M55.654,0H2.281A2.281,2.281,0,0,0,0,2.281V75.568a2.281,2.281,0,0,0,2.281,2.281H55.654a2.281,2.281,0,0,0,2.281-2.281V2.281A2.281,2.281,0,0,0,55.654,0Z"/><g transform="translate(28.968)"><path class="b" d="M217.2,0H190.515V77.849H217.2a2.281,2.281,0,0,0,2.281-2.281V2.281A2.281,2.281,0,0,0,217.2,0Z" transform="translate(-190.515)"/></g><g transform="translate(33.929 17.285)"><path class="c" d="M239.908,118.24H225.424a2.281,2.281,0,1,1,0-4.561h14.484a2.281,2.281,0,1,1,0,4.561Z" transform="translate(-223.143 -113.679)"/><g transform="translate(0 13.837)"><path class="c" d="M239.908,209.245H225.424a2.281,2.281,0,1,1,0-4.561h14.484a2.281,2.281,0,1,1,0,4.561Z" transform="translate(-223.143 -204.684)"/></g><g transform="translate(0 27.674)"><path class="c" d="M239.908,300.249H225.424a2.281,2.281,0,1,1,0-4.561h14.484a2.281,2.281,0,1,1,0,4.561Z" transform="translate(-223.143 -295.688)"/></g><g transform="translate(0 42.041)"><path class="c" d="M239.908,394.739H225.424a2.281,2.281,0,1,1,0-4.561h14.484a2.281,2.281,0,1,1,0,4.561Z" transform="translate(-223.143 -390.178)"/></g></g><g transform="translate(7.273 13.08)"><path class="d" d="M53.381,97.516a2.279,2.279,0,0,1-1.613-.668L48.5,93.583a2.281,2.281,0,0,1,3.225-3.225l1.652,1.652L58.7,86.695a2.281,2.281,0,0,1,3.225,3.225l-6.928,6.928A2.28,2.28,0,0,1,53.381,97.516Z" transform="translate(-47.835 -86.026)"/><g transform="translate(0 13.837)"><path class="d" d="M53.381,188.521a2.28,2.28,0,0,1-1.613-.668L48.5,184.588a2.281,2.281,0,0,1,3.225-3.225l1.652,1.652L58.7,177.7a2.281,2.281,0,0,1,3.225,3.225l-6.928,6.928A2.281,2.281,0,0,1,53.381,188.521Z" transform="translate(-47.835 -177.032)"/></g><g transform="translate(0 27.674)"><path class="d" d="M53.381,279.525a2.279,2.279,0,0,1-1.613-.668L48.5,275.592a2.281,2.281,0,0,1,3.225-3.225l1.652,1.652L58.7,268.7a2.281,2.281,0,0,1,3.225,3.225l-6.928,6.928A2.28,2.28,0,0,1,53.381,279.525Z" transform="translate(-47.835 -268.036)"/></g></g><path class="e" d="M425.662,7.741V55.27a2.281,2.281,0,0,1-2.281,2.281h-10.92a2.28,2.28,0,0,1-2.281-2.281V7.741a7.741,7.741,0,0,1,15.482,0Z" transform="translate(-347.813 0)"/><path class="f" d="M461.09,0V57.55h5.46a2.281,2.281,0,0,0,2.281-2.281V7.741A7.75,7.75,0,0,0,461.09,0Z" transform="translate(-390.982)"/><g transform="translate(62.367 14.431)"><path class="g" d="M410.18,94.91h15.482v4.561H410.18Z" transform="translate(-410.18 -94.91)"/></g><path class="h" d="M461.09,94.91h7.741v4.561H461.09Z" transform="translate(-390.982 -80.479)"/></svg>`;

const SCREEN_HEIGHT = Dimensions.get("window").height;
const SCREEN_WIDTH = Dimensions.get("window").width;

export default class ServicesPreviewScreen extends Component {
  // static navigationOptions = ({ navigation }) => {
  //   console.log("navigation", navigation.getParam("params").category2.item);

  //   const category3 = navigation.getParam("params").category2.item;

  //   return {
  //     tabBarVisible: false,
  //     headerTransparent: true,
  //     title: category3,
  //     headerTitleStyle: {
  //       fontWeight: "bold",
  //       color: "#333333",
  //       shadowOpacity: 0.1,
  //     },
  //   };
  // };
  static navigationOptions = {
    headerShown: false,
  };
  constructor(props) {
    super(props);
    const firestore = firebase.firestore();
    this.unsubscribeFirestore = () => {
      return;
    };
  }
  state = {
    assetsLoaded: false,
  };

  async componentDidMount() {
    console.log("navigation props", this.props.navigation);
    console.log("params", this.props.navigation.getParam("params"));
    console.log(!isNaN(this.props.navigation.getParam("params").image));
    await Font.loadAsync({
      "ProximaNovaA-Regular": require("../../../../assets/font/ProximaNovaA-Regular.ttf"),
      "ProximaNovaA-Bold": require("../../../../assets/font/ProximaNovaA-Bold.ttf"),
    });
    this.setState({ assetsLoaded: true });

    try {
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 200);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 400);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 500);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 500);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 600);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 1000);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 2000);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 4000);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 5000);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 8000);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 10000);
        });
      if (!global.myUID || !global.myProfileID) await global.setGlobals();
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 10000);
        });
      if (!global.myUID || !global.myProfileID)
        await new Promise((resolve) => {
          setTimeout(resolve, 100000);
        });
      if (!global.myUID || !global.myProfileID) await global.setGlobals();
      if (!global.myUID) return;
    } catch (err) {
      if (global.reportError) {
        global.reportError(err, "catches", "servicesPreview");
      }
    }
  }

  componentWillUnmount() {
    console.log("Component servicesPreview will unmount");
    this.unsubscribeFirestore();
  }

  render() {
    return (
      <ScrollView>
        <StatusBar barStyle="light-content" />
        <View
          style={{
            backgroundColor: "F5F5F5",
            flex: 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ImageBackground
            style={{
              width: "100%",
              height: SCREEN_HEIGHT * 0.3,

              borderBottomLeftRadius: 20,
              borderBottomRightRadius: 20,
              borderColor: "black",
              borderWidth: 0.5,
              shadowColor: "#000",
              shadowOpacity: 0.5,
            }}
            source={{ uri: this.props.navigation.getParam("params").image }}
          >
            <TouchableOpacity
              style={{ top: 20, padding: 10, magin: 10, zIndex: 1 }}
              onPress={() => this.props.navigation.goBack()}
            >
              <FontAwesome name="angle-left" size={44} color="blue" />
            </TouchableOpacity>
          </ImageBackground>

          <View
            style={{
              backgroundColor: "#e0dede",
              opacity: 0.5,
              bottom: 30,
              width: "100%",
              height: 30,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text
              style={{
                color: "black",
                fontFamily: "ProximaNovaA-Bold",
                fontSize: 22,
              }}
            >
              {this.props.navigation.getParam("params").category2.item ||
                this.props.navigation.getParam("params").category2}
            </Text>
          </View>
          <View style={{ width: SCREEN_WIDTH, top: 20 }}>
            <ShopPreview
              providerCategory1={
                this.props.navigation.getParam("params").category1
              }
              providerCategory2={
                this.props.navigation.getParam("params").category2.item ||
                this.props.navigation.getParam("params").category2
              }
              navigation={this.props.navigation}
              description="Providers near you"
              fontSize={16}
              cardWidth=""
            />
          </View>

          <View>
            <TouchableOpacity
              onPress={() => {
                this.props.navigation.navigate("homeSpecialRequest", {
                  category1: this.props.navigation.getParam("params").category1,
                  category2:
                    this.props.navigation.getParam("params").category2.item ||
                    this.props.navigation.getParam("params").category2,
                });
                global.reportStats("pressed_Fashion_SpecialRequest");
              }}
              style={{
                backgroundColor: "#00A85A",
                height: 100,
                width: "90%",
                margin: 22,
                borderRadius: 12,
                alignItems: "center",
                shadowColor: "#000",
                shadowOpacity: 0.05,
                flexDirection: "row",
                justifyContent: "space-around",
                bottom: 50,
              }}
            >
              <View style={{ marginLeft: 20 }}>
                <View style={{ width: 146 }}>
                  <Text
                    style={{
                      fontFamily: "ProximaNovaA-Bold",
                      fontSize: 14,
                      color: "#FFFFFF",
                    }}
                  >
                    Send Special Request
                  </Text>
                </View>

                <View style={{ width: 190 }}>
                  <Text
                    style={{
                      fontFamily: "ProximaNovaA-Regular",
                      fontSize: 12,
                      color: "#FFFFFF",
                    }}
                  >
                    Ask 20 providers near you if they have what you are looking
                    for
                  </Text>
                </View>
              </View>

              <View style={{ marginRight: 20 }}>
                <SvgCss xml={pencilIcon} />
              </View>
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView>
    );
  }
}
